import * as React from "react";

export const NotAuthorizedScreen = () => (
  <div className="flex-fill d-flex flex-column justify-content-center align-items-center">
    <div className="container row justify-content-center">
      <div className="col-md-6">
        <div className="box">
          <div className="box-header box-header-danger">Not authorized!</div>
          <div className="box-body">
            <p>You are missing required premissions to access the requested content.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);
